import Vue from 'vue'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import BootstrapSelect from 'bootstrap-select'
import axios from 'axios'
import VueAxios from 'vue-axios'
import App from "./App.vue";
import router from './router'
import Vuelidate from 'vuelidate'
import i18n from './i18n'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import Storage from 'vue-web-storage'
import auth from "./auth";
import store from "./store";
import { mapActions } from "vuex";
import qs from "qs";

Vue.config.productionTip = false
Vue.use(VueAxios, axios)
Vue.axios.defaults.baseURL = process.env.VUE_APP_ROOT_API_SERVER_URL;

Vue.use(BootstrapSelect)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(Storage, { drivers: ['session'] })

Vue.use(Vuelidate)
Vue.use(VueMoment, {
  moment
})

library.add(fas)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.prototype.$axios = axios;
Vue.prototype.$qs = qs;

new Vue({
  router,
  i18n,
  store,
  render: h => h(App),
  methods: {
    ...mapActions([
      "updateUser",
      "setAdminStatus"
    ])
  },
  async created() {
    try {
      this.$i18n.locale = navigator.language;
      this.$moment.locale(this.$i18n.locale);
      console.log("main.js calling ssoSilent...");
      console.log({router: this.$router, location: window.location, test: window.location.pathname.split(this.$router.options.base), base: this.$router.options.base });
      let ssoResponse = await auth.ssoSilent(window.location.pathname.split(this.$router.options.base)[1] + window.location.search);

      if (ssoResponse === null) {
        console.log("main.js ssoSilent returned false...");
        return;
      }

      let bearerToken = `bearer ${await auth.acquireToken()}`;

      this.$axios.defaults.headers.common = {
        Authorization: `${bearerToken}`
      };
    } catch (error) {
      console.error("startup error", error);
    } finally {
      this.$mount("#app");
    }
  }
});
